export default "__VITE_ASSET__BkxXw2dW__"